import React, { Fragment } from "react";

import "./CardContent.css";
import "../../../styles/uikit.css";

const CardContent = (props) => (
  <Fragment>
    <div className="c-content-accordion ">
      <section className="c-content-accordion__row  uk-open">
        <h2 className="c-content-accordion__title ">
          <div className="c-content-accordion__title-text">
            {props.cardTitle}
          </div>
        </h2>

        <div className="c-card__body c-card__body--content">
          {props.children}
        </div>
      </section>
    </div>
  </Fragment>
);
 
export default CardContent;